import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import * as firebase from 'firebase';
import '../css/index.css'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import Scroll from 'react-scroll';
import Header from './Header';
import Footer from './Footer';
import App from '../View/App';
import Login from '../View/Login';
import UserProfile from '../View/UserProfile';
import Answer from '../Tables/Answer';
import Faqs from '../post/Faqs';
import AuthorityBlogs from '../post/AuthorityBlogs';
import AuthorityDrafts from '../post/AuthorityDrafts';
import Mails from '../post/Mails';
import Reports from '../post/Reports';
import Table1 from '../Tables/table1';
import Table2 from '../Tables/table2';
import Table3 from '../Tables/table3';
import Table4 from '../Tables/table4';
import Table5 from '../Tables/table5';
import Table6 from '../Tables/table6';
import Table7 from '../Tables/table7';
import Table8 from '../Tables/table8';
import Table9 from '../Tables/table9';
import CMTable1 from '../Tables/cmTable1';
import CMTable2 from '../Tables/cmTable2';
import CMTable3 from '../Tables/cmTable3';
import CMTable4 from '../Tables/cmTable4';
import CMTable5 from '../Tables/cmTable5';
import CMTable6 from '../Tables/cmTable6';
import CMTable7 from '../Tables/cmTable7';
import CMTable8 from '../Tables/cmTable8';
import CMTable9 from '../Tables/cmTable9';
import FaqLists from '../post/FaqLists';
import AuthorityTag from '../post/AuthorityTag';
import AuthorityTags from '../post/AuthorityTags';
import AuthorityTagsa from '../post/AuthorityTagsa';
import AuthorityTagsb from '../post/AuthorityTagsb';
import NoMatch from '../View/noMatch';
import Disclaimer from '../View/Disclaimer';
import PrivacyPolicy from '../View/PrivacyPolicy';
import About from '../View/About';
import Contact from '../View/Contact';
import MedicalTeam from '../post/MedicalTeam';
import MedicalTeams from '../post/MedicalTeams';

export default class Wrap extends Component {
  constructor() {
    super();
    this.state = {
      totalTest: ''
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.handleScrollTop = this.handleScrollTop.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    window.addEventListener('scroll', this.handleScroll)
    const totalTestRef = firebase.database().ref().child('total')
    const isTest = ReactDOM.findDOMNode(this.refs.isTest)
    totalTestRef.on('value', snap => {
      this.setState({
        totalTest: snap.val().totalTest
      })
    })
    totalTestRef.on('child_changed', hassanp => {
      isTest.classList.add('isShow')
    })

  }

  handleScroll(event) {
    let scrollTop = event.target.body.scrollTop || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const checkHeader = ReactDOM.findDOMNode(this.refs.checkHeader);
    const goTop = ReactDOM.findDOMNode(this.refs.goTop);
    const isTest = ReactDOM.findDOMNode(this.refs.isTest);

    if ( scrollTop < 200 ) {
      checkHeader.classList.remove('isChange')
      goTop.classList.remove('isShow')
      
    } else {
      checkHeader.classList.add('isChange')
      goTop.classList.add('isShow')
    }
    if( scrollTop < 10 ) {
      isTest.classList.remove('isShow')
    } else {
      isTest.classList.remove('isShow')
    }
  }
  handleScrollTop() {
    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }
  render() {
    return(
      <Router history>
       <div className="wrap">
         <Header ref="checkHeader" />
         <div className="content">
          <div className="totalBox isShow" ref="isTest">檢測次數:{this.state.totalTest}</div>
           <Switch>
            <Route exact path="/" component={App} />
            <Route path="/Login" component={Login} />
            <Route path="/UserProfile" component={UserProfile} />
            <Route path="/Answer/:id" component={Answer} />
            <Route path="/Faqs/:id" component={Faqs} />
            <Route path="/AuthorityBlogs/:id" component={AuthorityBlogs} />
            <Route path="/MedicalTeams/:userId" component={MedicalTeams} />
            <Route path="/AuthorityDrafts/:id" component={AuthorityDrafts} />
            <Route path="/Mails/:id" component={Mails} />
            <Route path="/Reports/:id" component={Reports} />
            <Route path="/Table1" component={Table1} />
            <Route path="/Table2" component={Table2} />
            <Route path="/Table3" component={Table3} />
            <Route path="/Table4" component={Table4} />
            <Route path="/Table5" component={Table5} />
            <Route path="/Table6" component={Table6} />
            <Route path="/Table7" component={Table7} />
            <Route path="/Table8" component={Table8} />
            <Route path="/Table9" component={Table9} />
            <Route path="/CMTable1" component={CMTable1} />
            <Route path="/CMTable2" component={CMTable2} />
            <Route path="/CMTable3" component={CMTable3} />
            <Route path="/CMTable4" component={CMTable4} />
            <Route path="/CMTable5" component={CMTable5} />
            <Route path="/CMTable6" component={CMTable6} />
            <Route path="/CMTable7" component={CMTable7} />
            <Route path="/CMTable8" component={CMTable8} />
            <Route path="/CMTable9" component={CMTable9} />
            <Route path="/FaqLists" component={FaqLists} />
            <Route path="/AuthorityTag/:blogTag" component={AuthorityTag} /> 
            <Route path="/AuthorityTags/:secondTag" component={AuthorityTags} />
            <Route path="/AuthorityTagsa/:otherTag1" component={AuthorityTagsa} />
            <Route path="/AuthorityTagsb/:otherTag2" component={AuthorityTagsb} />
            <Route path="/Disclaimer" component={Disclaimer} />
            <Route path="/About" component={About} />
            <Route path="/Contact" component={Contact} />
            <Route path="/Privacy-Policy" component={PrivacyPolicy} />
            <Route path="/MedicalTeam" component={MedicalTeam} />
            <Route component={NoMatch} />
           </Switch>
         </div>
         <Footer />
         <div ref="goTop" className="goTop" onClick={this.handleScrollTop}>Top</div>
       </div>
      </Router>
    )
  }
}




// WEBPACK FOOTER //
// ./src/Layout/Wrap.js